import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User } from 'lucide-react';
import axios from 'axios';
import { API_URL } from '../config';
import logo from '../unify_logo.png'; // ✅ IMPORT YOUR NEW LOGO

const Login = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  // API_URL is now managed in src/config.js
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const res = await axios.post(`${API_URL}?action=login`, formData);
      
      if (res.data.success) {
        localStorage.setItem('isAuthenticated', 'true'); 
        localStorage.setItem('user', JSON.stringify(res.data.user)); 
        setIsAuthenticated(true);
        navigate('/'); 
      } else {
        setError(res.data.message);
      }
    } catch (err) {
      console.error(err);
      setError("Server error. Check connection.");
    }
  };

  return (
    // ✅ UPDATED: Changed background to Green Gradient to match Logo
    <div className="min-h-screen bg-gradient-to-br from-green-800 to-teal-900 flex items-center justify-center">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-96 border border-gray-200">
        
        <div className="flex flex-col items-center mb-6">
            
            {/* ✅ LOGO DISPLAY - Matching the first picture */}
            <div className="flex items-center gap-3 bg-teal-800 px-5 py-3 rounded-xl shadow-sm mb-4">
              <img 
                  src={logo} 
                  alt="UNiFy Rx" 
                  className="h-10 w-auto object-contain" 
              />
              <div className="text-left">
                <div className="text-2xl font-black text-white tracking-tight leading-none">UNiFy Rx</div>
                <div className="text-xs font-bold text-teal-200 uppercase tracking-widest mt-0.5">CRM Suite</div>
              </div>
            </div>

            <p className="text-gray-500 text-xs font-bold uppercase tracking-widest mb-4">Authorized Access Only</p>
            <div className="h-1 w-16 bg-green-600 rounded-full mb-6"></div>
        </div>

        {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4 text-sm text-center">
                {error}
            </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
            <div className="relative">
                <User className="absolute left-3 top-2.5 text-gray-400" size={18} />
                <input 
                    type="text" name="username" required 
                    className="pl-10 w-full border p-2 rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
                    placeholder="Enter username"
                    value={formData.username} onChange={handleChange}
                />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <div className="relative">
                <Lock className="absolute left-3 top-2.5 text-gray-400" size={18} />
                <input 
                    type="password" name="password" required 
                    className="pl-10 w-full border p-2 rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
                    placeholder="Enter password"
                    value={formData.password} onChange={handleChange}
                />
            </div>
          </div>

          <button type="submit" className="w-full bg-green-700 text-white font-bold py-2.5 rounded-lg hover:bg-green-800 transition shadow-md">
            Sign In
          </button>
        </form>
        
        <p className="text-center text-[10px] text-gray-400 mt-6">
            &copy; 2025 Protected by HIPAA Compliance
        </p>
      </div>
    </div>
  );
};

export default Login;